var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14.14,
    height: 12.38,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.227956 5.45991L3.21672 6.57779L4.38182 10.3379C4.43248 10.592 4.73642 10.6428 4.93905 10.4904L6.61072 9.11843C6.76269 8.96599 7.01598 8.96599 7.21861 9.11843L10.2074 11.3034C10.41 11.4558 10.7139 11.3542 10.7646 11.1001L12.9935 0.429444C13.0441 0.17538 12.7909 -0.0786813 12.5376 0.0229443L0.227956 4.79935C-0.0759852 4.90097 -0.0759852 5.35828 0.227956 5.45991ZM4.22986 6.01885L10.106 2.41114C10.2073 2.36033 10.3087 2.51277 10.2074 2.56358L5.39496 7.08592C5.24299 7.23836 5.09101 7.44161 5.09101 7.69567L4.93905 8.91518C4.93905 9.06762 4.68576 9.11843 4.63511 8.91518L4.02722 6.67942C3.87525 6.42535 3.97657 6.12047 4.22986 6.01885Z",
    fill: "#2D9CDB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.666194bd40d659337c034be4d70867d1.svg";
export { ForwardRef as ReactComponent };